module.exports = __webpack_public_path__ + "img/title-heros.6d8bae48.png";